import { render, staticRenderFns } from "./roleTableHead.vue?vue&type=template&id=efdc6572&scoped=true&"
import script from "./roleTableHead.vue?vue&type=script&lang=js&"
export * from "./roleTableHead.vue?vue&type=script&lang=js&"
import style0 from "./roleTableHead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./roleTableHead.vue?vue&type=style&index=1&id=efdc6572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdc6572",
  null
  
)

export default component.exports